import { useQuery } from "@tanstack/react-query";
import { getDataAllCertificate, getFields } from "../../../services/api";
import AgroMapFarm from "../../../features/map/presentation/components/AgroMapFarm";
import { toolbarBaseControls } from "../../../features/map/utils/configs";
import { FieldMarkerIcon } from "../../../components/map/utils/customs";
import ReactQueryAsyncValueWrapper from "../../../shared/components/wrappers/ReactQueryAsyncValueWrapper";
import TimelineChart from "../../../components/maptimeline/TimelineChart";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import moment from "jalali-moment";
import ItemFieldSeason from "./ItemFieldSeason";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import AddNewGrowingSeasonButton from "../../../components/GrowingSeasons/components/AddNewGrowingSeasonButton";
import { productColors } from "../../../features/map/utils/polygon-border-color";

export default function MapPolygonView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [timelineEvents, setTimelineEvents] = useState([]);
  const [currentPolygon, setCurrentPolygon] = useState(null);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const { fieldObject } = location.state || {};
  const [searchParams, setSearchParams] = useSearchParams();
  const farmerFarmsQuery = useQuery(["fields"], getFields);
  const [farmId, setFarmId] = useState(searchParams.get("id"));
  const [polygonMap, setPolygonMap] = useState(fieldObject?.polygon || null);

  // کوئری کل دیتای شناسنامه زمین
  const getDataAllCertificateQuery = useQuery(
    ["getDataAllCertificate", farmId],
    () => getDataAllCertificate(farmId),
    {
      enabled: !!farmId,
      onError: (error) => console.error("Query Error:", error),
      onSuccess: (data) => {},
      placeholderData: {},
    }
  );

  const generateIconUrl = (name, id) => {
    return `https://agroyaar-static.s3.ir-thr-at1.arvanstorage.ir/icons/products/${name}-p=${id}.png`;
  };

  const textMap = true;

  useEffect(() => {
    if (getDataAllCertificateQuery.isFetched) {
      const events = getDataAllCertificateQuery.data?.seasons?.map((season) => {
        const growingSeasonData = {
          ...season,
          harvestDate: moment(season?.harvestDate)
            .locale("fa")
            .format("YYYY-MM-DD"),
          plantingDate: moment(season?.plantingDate)
            .locale("fa")
            .format("YYYY-MM-DD"),
        };
        const growingSeasonYear = moment(
          `${season.growingSeason}-04-01`,
          "YYYY-MM-DD"
        )
          .locale("fa")
          .format("YYYY");

        return {
          id: season.id,
          name: `${growingSeasonYear} ${
            season.persianName ? `- ${season.persianName}` : ""
          }`,
          date: growingSeasonData.harvestDate,
          product: season.product,
          timeLineDescription: season.product?.persianName,
          description: season.description,
          polygon: season.polygon,
          color: season.product?.productId
            ? productColors[`${season.product?.productId}`]
            : "#C2C2C2",
          cultivarName: season.cultivarName,
          irrigationSystem: season.irrigationSystem.name,
          plantingDate: growingSeasonData.plantingDate,
          density: season.density,
          usedSeedAmount: season.usedSeedAmount,
          icon: generateIconUrl(
            season.product?.name,
            season.product?.productId
          ),
        };
      });
      setTimelineEvents(events);
    }
  }, [getDataAllCertificateQuery.data]);

  useEffect(() => {
    if (farmId) {
      const selectedFarm = farmerFarmsQuery.data?.farms.find(
        (farm) => farm.id === farmId
      );
      if (selectedFarm) {
        setPolygonMap(selectedFarm.polygon);
      }
    }
  }, [farmId, farmerFarmsQuery.data]);

  return (
    <ReactQueryAsyncValueWrapper state={farmerFarmsQuery}>
      {(farmerFarms) => {
        return (
          <div className="flex flex-col  gap-6 items-start max-lg:items-center justify-center p-4">
            <div className="box-shadow p-2 !rounded-[20px] w-full max-lg:w-[100vw] h-fit">
              <div className="relative flex flex-col inner-circle-neo justify-center items-center overflow-clip !rounded-[20px] max-lg:!rounded-none h-[78vh] w-full max-lg:h-[100%] max-lg:fixed max-lg:top-0 max-lg:left-0 z-[2] max-lg:z-[9999999999]">
                <div className="absolute left-4 top-4 z-[9999] ">
                  <ItemFieldSeason seasonData={selectedSeason} />
                </div>
                <div
                  className="ball z-[1001] cursor-pointer hover:brightness-105 !border-none flex items-center justify-center rounded-full !w-8 !h-8 p-2 text-[#969696] font-extrabold text-xl absolute top-3 max-lg:top-8 right-3 max-lg:left-1"
                  dir="ltr"
                  onClick={() => navigate("/my-fields")}
                >
                  <ArrowRightOutlined />
                </div>
                <AgroMapFarm
                  type="onlyShow"
                  mapId="2005566"
                  markerIcon={FieldMarkerIcon}
                  toolbarOptions={{
                    ...toolbarBaseControls,
                  }}
                  currentFarmPolygon={polygonMap}
                  farmerFarms={farmerFarms.farms}
                  farmSeasons={selectedSeason ? [selectedSeason] : undefined}
                  currentSeasonPolygon={currentPolygon}
                  onFarmClick={(farmId) => {
                    searchParams.set("id", farmId);
                    setSearchParams(searchParams);
                    setFarmId(farmId);
                  }}
                />
                {!!farmId ? (
                  timelineEvents.length > 0 ? (
                    <div className="absolute w-[740px] z-[999] -bottom-[330px] hover:-translate-y-[330px] duration-700 ">
                      <TimelineChart
                        events={timelineEvents}
                        onEventClick={(clickedId) => {
                          setSelectedSeason(
                            timelineEvents.find(
                              (event) => event.id === clickedId
                            )
                          );
                        }}
                      />
                    </div>
                  ) : (
                    <>
                      <div className=" absolute bottom- z-[999] mx-auto text-white flex flex-col gap-4 items-center justify-center ">
                        <p>تا کنون در این زمین، هیچ فصل رشدی ثبت نشده است</p>
                        <AddNewGrowingSeasonButton
                          farmId={farmId}
                          map={textMap}
                        />
                      </div>
                    </>
                  )
                ) : null}
              </div>
            </div>
          </div>
        );
      }}
    </ReactQueryAsyncValueWrapper>
  );
}
